import { useIsReactNativeWebView } from '@/lib/react-native/contexts/react-native/ReactNativeProvider.client'
import { useEffect } from 'react'
import { useIsMounted } from 'usehooks-ts'

/**
 * A hook that adjusts the bottom padding of the document when a bottom bar is present in a webview.
 * @param barRef a ref to a div element
 */
export function useWebviewBottomBarPadding(barRef: React.RefObject<HTMLDivElement | null>) {
  const isMounted = useIsMounted()
  const isInWebView = useIsReactNativeWebView()

  useEffect(() => {
    if (!isInWebView || !barRef.current || !isMounted()) return

    const observer = new ResizeObserver((entries) => {
      // Needed to also account for bottomBar paddings
      const height = barRef.current?.getBoundingClientRect().height ?? 0

      entries.map((_) => {
        document.documentElement.style.setProperty('padding-bottom', `${height}px`)
      })
    })
    observer.observe(barRef.current)

    return () => {
      observer.disconnect()
      document.documentElement.style.removeProperty('padding-bottom')
    }
  }, [barRef, isMounted, isInWebView])
}
